import React, { useState, useEffect } from "react";
import Layout from "../../layouts/index";
import "../../styles/our-solutions.scss";
import { Link } from "gatsby";
import "bootstrap/dist/css/bootstrap.min.css";
import { data } from "../../constants/solutionConstant";
// import { Helmet } from "react-helmet";
import Slider from "react-slick";
import { SEO } from "../../components/SEO";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import z1 from "../../images/z1.svg";
import z2 from "../../images/z2.svg";
import z3 from "../../images/z3.svg";
import z4 from "../../images/z4.svg";
import Modal from "../../components/modal";
import { isBrowser } from "../../utils/common";
import SolutionSlider from "../../components/solutionSlider";
import { downloadApp } from "../../constants/linkConstant";
import Breadcrumb from "../../components/breadcrumb";

const solMobText = [
  {
    header: "EARNED WAGE ACCESS",
    subtitle: "Early on-demand access to accrued earnings",
  },
  {
    header: "LINE OF CREDIT",
    subtitle: "Higher limits to supplement earnings for sudden emergencies",
  },
  {
    header: "PERSONAL LOAN",
    subtitle: "Larger loans payable over multiple installments",
  },
  {
    header: "EARNED WAGE ACCESS",
    subtitle: "Early on-demand access to accrued earnings",
  },
  {
    header: "LINE OF CREDIT",
    subtitle: "Higher limits to supplement earnings for sudden emergencies",
  },
  {
    header: "PERSONAL LOAN",
    subtitle: "Larger loans payable over multiple installments",
  },
];

const OurSolutionPage = ({ location }) => {
  useEffect(() => isBrowser() && window.scrollTo(0, 0), []);

  const [solutionTab, setSolutionTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState();
  const [imgIndex, setImgIndex] = useState(0);

  const changeSolutionTab = (index) => {
    setSolutionTab(index);
  };
  const modalBlock = (video) => {
    setShowModal(true);
    setVideoUrl(video);
  };
  const modalCallback = () => {
    setShowModal(false);
  };

  const settingsVideoSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* <Helmet>
        <title>Karmalife | Our Solutions</title>
        <meta
          name="description"
          content="India’s Largest Earned Wage Access Platform.We provide earnings-linked, affordable credit solutions to low income workers. Today we serve over 2M+ blue collar and gig workers in India. Learn more about us."
        />
      </Helmet> */}
      {/* <Breadcrumb location={location} crumbLabel="Our Solutions" /> */}

      <section className="solutions-sec">
        <div className="container">
          <div className="solution-Hd">{data.heroSection.title}</div>
          <div className="hide-mobile">
            <ul className="solution-sec-wrapper">
              {data.heroSection.data.map((item, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => changeSolutionTab(index)}
                    className={solutionTab === index ? `active` : ``}
                  >
                    <strong>{item.title}</strong>
                    <figure>
                      <img src={item.image} alt="" height={450} />
                    </figure>
                    <p>{item.content}</p>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="row">
            <div className="solution-slider-wrapper">
              <div className="solution-slider show-mobile">
                <div className="header-style">
                  {solMobText[imgIndex]?.header}
                </div>
                <SolutionSlider {...{ imgIndex, setImgIndex }} />
                <div className="subtitle-style">
                  {solMobText[imgIndex]?.subtitle}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="users-sec">
        <div className="container">
          <div className="partners-hd our-s">{data.userSection.title}</div>
          <div className="on-call">
            <div className="flex-onCall">
              {data.userSection.data.map((item, index) => {
                return (
                  <div key={index} className={`support ${item.clas}`}>
                    <img src={item.image} alt={item.altText} />
                    <h2>
                      {item.bold} <span className="d-block"> {item.small}</span>{" "}
                    </h2>
                  </div>
                );
              })}
            </div>

            {/* <div className="btn-view">
              <button>{data.userSection.buttonText}</button>
            </div> */}
          </div>
        </div>
      </section>

      <section className="partners-sec">
        <div className="container">
          <div className="partners-hd">{data.partnerSection.title}</div>
          <div className="mw-partnerBox">
            <div className="row">
              {data.partnerSection.data.map((item, index) => {
                return (
                  <div key={index} className="col-md-6">
                    <div className={`reductionBox ${item.clas}`}>
                      <h2>
                        {item.bold} <span>{item.small}</span>
                      </h2>
                      <h5>{item.subTitle}</h5>
                      <h4>
                        <img src={item.image} alt={item.altText} />
                      </h4>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* new section */}
      <section className="user-solu">
        <div className="container">
          <div className="soln-hd">Why users love our solutions</div>
          <p>
            KarmaLife helps in increasing employee productivity <br /> by
            increasing employee satisfaction.
          </p>
          <div className="img-section">
            <img className="img_layer" src={z1} alt="Karmalife Advance Salary" />
            <img className="img_layer" src={z2} alt="Karmalife Easy Credit" />
            <img className="img_layer" src={z3} alt="Karmalife Advance Salary" />
            <img className="img_layer" src={z4} alt="Karmalife Advance Salary" />
          </div>
          <div className="soln-bd">
            {" "}
            Source: <span className="soln-bd-weight"> 60decibels,</span> a third
            party benchmarking survey
          </div>
          <div className="btn-view">
            <Link
              to="http://blog.karmalife.ai/wp-content/uploads/2023/03/60db_karmalife.pdf"
              target="_blank"
            >
              <button>{data.userSection.buttonText}</button>
            </Link>
          </div>
        </div>
      </section>

      <section className="karmaLife_App-sec">
        <div className="container">
          <div className="stories-txt">{data.storiesSection.title}</div>
          <div className="slider-content">
            <Slider {...settingsVideoSlider}>
              {data.storiesSection.data.map((item, index) => {
                return (
                  <div key={index} className="item">
                    {/* <div
                      className="sliderBox-one"
                      onClick={() => modalBlock(item.videoUrl)}
                    > */}
                    {/* <img src={item.image} alt="" /> */}
                    <div className="iframe-style">
                      <iframe
                        frameborder="4"
                        scrolling="no"
                        // width="150 !important"
                        // height="314"
                        type="text/html"
                        src={item.videoUrl}
                      ></iframe>
                      {/* <h2>{item.title}</h2>
                      <p>{item.subTitle}</p> */}
                      <span>
                        {/* <img src={item.videoThumbnail} alt="" > */}

                        {/* <img src={item.videoThumbnail} alt=""/> */}
                      </span>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>

          <div className="solution-Hd">{data.appSection.title}</div>
          <div className="input-email">
            <div className="btn-view">
              {/* <input type="text" placeholder={data.appSection.placeholderText}/> */}
              <Link to={downloadApp} target="_blank">
                <button>{data.appSection.buttonText}</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {showModal && <Modal Url={videoUrl} CallBack={modalCallback} />}
    </>
  );
};

export default OurSolutionPage;

export const Head = () => (
  <SEO
    title="Karmalife | Our Solutions"
    description="We provide earnings-linked, affordable credit solutions to low income workers. Today we serve over 2M+ blue collar and gig workers in India. Learn more about us."
    pathname={"/our-solutions"}
  />
);
